import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { LoginSuccessResponse } from "./LoginSuccessResponse";
import { getSessionByUrn } from "../../services/api";
import { useQuery } from "@tanstack/react-query";


const LoginComplete = () => {
  const navigate = useNavigate()
  const { inProgress } = useMsal();
  const { pathname } = useLocation();
  const { data } = useQuery({
    queryKey: ["GetSessionUrn"],
    queryFn: getSessionByUrn,
  })

  React.useEffect(() => {
    if (pathname === "/logout") {
      const entryPath = localStorage.getItem("paylink_entry_path") ?? "";
      const isStorePath = /^\/paylink\/s\/[^/]+(\/p\/[^/]+)?$/.test(entryPath);
      if (isStorePath) {
        navigate(entryPath, { replace: true });
        return;
      }

      try {
        const storedProfile = localStorage.getItem("paylink_store_profile");
        if (storedProfile) {
          const profile = JSON.parse(storedProfile);
          if (profile?.slug) {
            navigate(`/paylink/s/${profile.slug}`, { replace: true });
            return;
          }
        }
      } catch {
        // Ignore
      }

      navigate("/login");
    }
  }, [navigate, pathname]);

  React.useEffect(() => {
    if (pathname === "/logout") {
      if (inProgress === InteractionStatus.Startup) {
        // localStorage.removeItem("session_data");

        return;
      }
    }
  }, [pathname]);



  const handleSuccessCheckout = () => {

  }

  console.log({ data })

  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <LoginSuccessResponse />
      </div>
    </>
  );
};

export default LoginComplete;
